/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsMessagingTelegramSend: {
  name: 'messaging-telegram-send';
  data: string;
} = {
  name: 'messaging-telegram-send',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><g clip-path="url(#a)"><path fill-rule="evenodd" clip-rule="evenodd" d="M.566 1.248 4.424 8 .566 14.752a.5.5 0 0 0 .658.695l14-7a.5.5 0 0 0 0-.894l-14-7a.5.5 0 0 0-.658.695ZM5.29 7.5 2.253 2.186 12.882 7.5H5.29Zm0 1-3.037 5.314L12.882 8.5H5.29Z" fill="currentColor"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h16v16H0z"/></clipPath></defs></svg>`,
};
